import React from 'react';
import { toWords } from 'number-to-words';
import PropTypes from 'prop-types';
import UnAnsweredQuestion from 'chameleon/packages/blue-book-player/InnerContainer/SubmitConfirmDialog/UnAnsweredQuestions/UnAnsweredQuestion';

const UnAnsweredQuestions = (props) => {
  const { questions, onNavigateToQuestion, getQuestionPosition } = props;
  const questionText =
    questions.length > 1 ? ' questions are ' : ' question is ';
  let countWord = toWords(questions.length);
  countWord = countWord.charAt(0).toUpperCase() + countWord.slice(1);

  return (
    <div className="flex flex-col gap-2">
      <div className="font-medium leading-normal">
        {`${countWord} ${questionText} unanswered.`}
      </div>
      <ul className="flex flex-col gap-2 bb-desktop:max-h-40 overflow-auto list-none pl-0">
        {/* learnosity returns zero based see getQuestionPosition in Parent Component */}
        {questions.map((question) => (
          <li key={question}>
            <UnAnsweredQuestion
              onClick={() => onNavigateToQuestion(question)}
              title={`Question ${getQuestionPosition(question) + 1}`}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

UnAnsweredQuestions.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.string).isRequired,
  onNavigateToQuestion: PropTypes.func.isRequired,
  getQuestionPosition: PropTypes.func.isRequired,
};

export default UnAnsweredQuestions;
